<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->

<div class="header-actions">
  <div class="backIcon ml-4" *ngIf="isShow == true">
    <img src="../../../../assets/images/back_wetap.svg" (click)="back()" />
  </div>
  <div class="title ml-4 d-flex">
    {{ title }}
    <!-- <span class="d-sm-none d-block ml-4" *ngIf="showRefresh == true">
      <img
        src="../../../../assets/images/refresh_search.svg"
        style="height: 20px"
        (click)="sendData()"
      />
    </span> -->
  </div>
  <div class="logout mr-4">
    <!-- <div class="logoutText"><span class="p_">Logout</span></div> -->
    <i
      class="fas fa-sign-out signoutIcon position-relative ml-2 mt-2 mb-2"
      (click)="logoutUser()"
      style="cursor: pointer; font-size: 21px"
      mat-icon-button
    >
    </i>
  </div>
</div>
